import { bootstrapApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { WidgetComponent } from './app/widget/widget.component';
import './polyfills';

bootstrapApplication(WidgetComponent).then((appRef) => {
  const widgetElement = createCustomElement(WidgetComponent, {
    injector: appRef.injector,
  });
  customElements.define('juspedia-search', widgetElement);
});
